import { FormControlLabel, GridColumn, Switch, Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";

export default () => {
	const label = "This will be a long enough label that it should be forced to wrap";

	return (
		<CssColumnGrid centerContent columns={2}>
			<Text semiBold text="default (wrap)" />
			<Text semiBold text="don't wrap" />
			<GridColumn
				border="1px solid silver"
				spacing={2}
				spacingAround={2}
				width={250}
			>
				<FormControlLabel
					control={<Switch checked={false} />}
					label={label}
					labelPlacement="start"
				/>
				<FormControlLabel
					control={<Switch checked={false} />}
					label={label}
					labelPlacement="end"
				/>
				<FormControlLabel
					control={<Switch checked={false} />}
					label={label}
					labelPlacement="top"
					wrap
				/>
				<FormControlLabel
					control={<Switch checked={false} />}
					label={label}
					labelPlacement="bottom"
					wrap
				/>
			</GridColumn>
			<GridColumn
				border="1px solid silver"
				spacing={2}
				spacingAround={2}
				width={250}
			>
				<FormControlLabel
					control={<Switch checked={false} />}
					label={label}
					labelPlacement="start"
					wrap={false}
				/>
				<FormControlLabel
					control={<Switch checked={false} />}
					label={label}
					labelPlacement="end"
					wrap={false}
				/>
				<FormControlLabel
					control={<Switch checked={false} />}
					label={label}
					labelPlacement="top"
					wrap={false}
				/>
				<FormControlLabel
					control={<Switch checked={false} />}
					label={label}
					labelPlacement="bottom"
					wrap={false}
				/>
			</GridColumn>
		</CssColumnGrid>
	);
};